module.exports = __webpack_public_path__ + "static/leatherfactory-logo-f477a189ed35c7883aceff1a062fa56f.jpeg";